module.exports = "<!-- ko template: { name: templateData.name, data: templateData.data, afterRender: templateData.afterRender } -->\n<!-- /ko -->\n";